export const CameraPosition = {
  TOP: 0,
  BOTTOM: 1
}

export const ShippingStep = {
  Step1: { Index: 1, Label: 'Step1', Title: 'レポートの取り込み', Notes: ['「注文レポート」をダウンロードしてスタートボタンを押して下さい'], Next: 'スタート' },
  Step2: { Index: 2, Label: 'Step2', Title: '出荷商品を選択', Notes: ['本日出荷する商品を選択し、作成ボタンを押してください', 'キャンセル依頼等、発送しない商品はチェックマークを外してください'], Next: '確認作業へ' },
  Step3: { Index: 3, Label: 'Step3', Title: '確認作業', Notes: ['住所の不備がある箇所の確認を行ってください', 'また配送の指定がある場合には「メモ」を使用してください'], Next: '印刷へ' },
  Step4: { Index: 4, Label: 'Step4', Title: '印刷', Notes: ['領収書を印刷してください', '印刷しない商品はチェックマークを外してください'], Next: '完了' }
}

export const UploadDataType = {
  Undefined: { Index: -1, Label: '読み取り不可', Image: false, imported: false },
  None: { Index: 0, Label: 'データなし', Tip: 'ファイルをアップロードしてください', Image: false, imported: false },
  Amazon: { Index: 1, Label: 'Amazon', Tip: 'Amazon', Image: true, src: require('@/assets/upload/Amazon_logo.png'), imported: true },
  JapaneseBook: { Index: 2, Label: '日本の古本屋', Image: true, src: require('@/assets/upload/JapaneseBook.png'), imported: true },
  YahooAuction: { Index: 3, Label: 'ヤフオク', Image: true, src: require('@/assets/upload/YahooAuction.png'), imported: true }
}

export const ShipMethod = {
  PostMail: { Index: 0, Label: 'ゆうメール' },
  Nekopos: { Index: 1, Label: 'ネコポス' },
  PostPack: { Index: 2, Label: 'ゆうパック' }
}

export const AutoMemo = {
  More: { Index: 0, Label: '数量n個での注文です' },
  PostOffice: { Index: 1, Label: '郵便局系で配送(ゆうパックでお願いします)' },
  Stamp: { Index: 2, Label: '収入印紙を貼り付けてください' },
  Packing: { Index: 3, Label: '高額のためプチプチ梱包' }
}

export const ManualSelectMemo = {
  None: { Index: 0, Label: '特になし' },
  PostOffice: { Index: 1, Label: '郵便局系で配送(ゆうパックでお願いします)' },
  Fast: { Index: 2, Label: '速達で配送(【1】ネコポス 【2】ゆうパックの順で' },
  Douhuu: { Index: 3, Label: '同封書類なし(【1】ゆうメール規格外 【2】ネコポス規格外 【3】ゆうパックの順で発送' }
}
